import { Trans, useTranslation } from "react-i18next";
import defaultContent from "../../../content/common";
import "./BonusInfoFooter.scss";
import { TimeStamp } from "../TimeStamp/TimeStamp";
import { ReactNode } from "react";

type Props = {
  hideDate?: boolean;
  additionalNode?: ReactNode;
};

export const BonusInfoFooter = (props: Props) => {
  const { t } = useTranslation(["common"]);
  const { hideDate = true, additionalNode } = props;

  return (
    <section className="bonus-footer-container" aria-label="Disclaimer">
      {hideDate === false && (
        <section className="short-date">
          <TimeStamp dateFormat={"bigEndian"} />
        </section>
      )}
      <br />
      <div className="bonus-footer-desc">
        <section className="market-disclaimer">
          <>{t("marketDisclaimer", defaultContent["marketDisclaimer"])}</>
        </section>
        <br />
        <section>
          <>{t("totalsDisclaimer", defaultContent["totalsDisclaimer"])}</>
        </section>
        <br />
        <section>
          <Trans
            i18nKey={"bonusesDisclaimer"}
            ns="common"
            defaults={defaultContent["bonusesDisclaimer"]}
            components={{
              em: <em />,
              br: <br />,
            }}
          ></Trans>
        </section>
        <br />
        <section>
          <Trans
            i18nKey={"footer"}
            ns="common"
            defaults={defaultContent["footer"]}
            components={{
              // displays only for ANA
              1: (
                <a href="http://amway.com/en_US/money-and-rewards" id="bonus-info-footer-link">
                  <span className="sr-only">Learn more about Money and Rewards Link</span>
                </a>
              ),
              br: <br />,
            }}
          ></Trans>
        </section>
        <section>{additionalNode}</section>
      </div>
    </section>
  );
};
